import { Routes } from "@angular/router";
import { FullLayoutComponent } from "./share/layouts/full-layout/full-layout.component";

export const APP_ROUTES: Routes = [
	{
		path: "",
		loadChildren: () => import("./home/home-routing.module").then((r) => r.HOME_ROUTES)
	},
	{
		path: "referral",
		loadChildren: () =>
			import("./referral/referral-routing.module").then((r) => r.REFERRAL_ROUTES)
	},

	{
		path: "**",
		redirectTo: "authentication/404"
	}
];
